import Entity from "@/services/westore/entities/entity";

export class InboundShipment extends Entity {
  static uri = "/shipments";

  static store(payloadRequest) {
    return super.create(InboundShipment.uri, payloadRequest);
  }

  static getTemplate(params = {}) {
    return super.getAll(`${InboundShipment.uri}/template`, params);
  }

  static getOne(id, params = {}) {
    return super.get(InboundShipment.uri, id, params);
  }
  static cancel(id, params = {}) {
    return super.get(`${InboundShipment.uri}/cancel`, id, params);
  }
  static getAll(params = {}) {
    return super.getAll(InboundShipment.uri, params);
  }
  static getInboundItems(params = {}, id) {
    return super.getAll(`${InboundShipment.uri}/${id}/items`, params);
  }
  static getOptions(params = {}) {
    return super.getAll(`${InboundShipment.uri}/options`, params);
  }

  static export(type = "xlsx", filter) {
    const endpoint = `${InboundShipment.uri}/export?type=${type}`;
    return super.get(endpoint, null, filter);
  }
}
